import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import NfibComHeader from '../NfibSiteChrome/NfibComHeader';
import OnboardingAccountHeader from '../OnboardingAccountHeader';
import { isOnboardingAccountPath } from '../layoutPathUtils';

const Header = ({ location, showMenu, menuItems, docTitle }) => {
  if (!showMenu) {
    return null;
  }
  const pathname = (location && location.pathname) || '';
  if (isOnboardingAccountPath(pathname)) {
    return <OnboardingAccountHeader />;
  }
  return (
    <NfibComHeader
      menuItems={menuItems}
      showMenu={showMenu}
      docTitle={docTitle}
    />
  );
};

Header.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  showMenu: PropTypes.bool,
  menuItems: PropTypes.array,
  docTitle: PropTypes.string,
};

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/common/components/Layout/Header/index.js